<template>
  <div>
    <div class="flex justify-between">
      <p class="mb-2 overflow-hidden text-base whitespace-nowrap overflow-ellipsis text-newColors-gray-contentB">{{ breadcrumb }}</p>
      <button @click="closeItemInfo" class="flex items-baseline ml-3 text-xl shrink-0 font-futuraEfBook hover:underline focus:outline-black-alt" type="button" @click.prevent="fullScreen">
        <img width="24" height="24" src="../../../assets/images/cross-black.svg" /><span class="hidden">{{ translations.close }}</span>
      </button>
    </div>
    <h3 class="mb-6 text-xl line-clamp text-newColors-gray-content" :title="item.title">{{ item.title }}</h3>

    <div class="flex items-center mb-2">
      <img class="mr-2" :src="selectedIcon" />
      <span class="text-xl font-futuraEfDemiBold text-newColors-gray-content">{{ translations[item.projectState.toLowerCase()] }}</span>
    </div>
    <p v-if="item.description" class="mt-2 text-lg text-newColors-gray-content">{{ item.description }}</p>
    <div v-if="item.startDate || item.endDate" class="flex flex-col px-3 py-4 mt-4 gap-y-2 rounded-xl" :class="stateBackgroundColor">
      <template v-if="item.startDate">
        <div class="flex flex-row items-center justify-between">
          <p class="flex items-center col-span-1 text-lg leading-6 font-futuraEfDemiBold text-newColors-gray-content">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="mr-2">
              <path d="M12 7V12L14.5 13.5M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="#2C2827" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            <span class="text-right font-inherit">{{ translations.startDate }}</span>
          </p>
          <p class="col-span-1 text-lg leading-6 text-newColors-gray-content">
            {{ capitalizeFirstLetter(item.startDate) }}
          </p>
        </div>
      </template>
      <template v-if="item.endDate">
        <div class="flex flex-row items-center justify-between">
          <p class="flex items-center col-span-1 text-lg leading-6 font-futuraEfDemiBold text-newColors-gray-content">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="mr-2">
              <path d="M8 12.3333L10.4615 15L16 9M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="#2C2827" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            <span class="font-inherit">{{ translations.endDate }}</span>
          </p>
          <p class="col-span-1 text-lg leading-6 text-newColors-gray-content">
            {{ capitalizeFirstLetter(item.endDate) }}
          </p>
        </div>
      </template>
    </div>

    <button v-if="item.projectUrl?.length > 0" @click="GoToUrl" type="button" class="w-full !text-lg btn-primary mt-5">{{ translations.buttonLabel }}</button>
  </div>
</template>
<script setup>
import { defineProps, defineEmits, computed } from 'vue'

var props = defineProps({
  translations: {
    type: Object,
    default: () => {}
  },
  item: {
    type: Object,
    default: () => {}
  },
  inStyleguide: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['closeItemInfo'])

const icons = {
  ongoing: `${props.inStyleguide ? 'src/assets/images' : '/gui-web/img'}/project-map-ongoing-icon.svg`,
  planned: `${props.inStyleguide ? 'src/assets/images' : '/gui-web/img'}/project-map-planned-icon.svg`,
  finished: `${props.inStyleguide ? 'src/assets/images' : '/gui-web/img'}/project-map-finished-icon.svg`
}

const stateBackgroundColor = computed(() => {
  switch (props.item.projectState.toLowerCase()) {
    case 'ongoing':
      return 'bg-newColors-orange-signatureB'
    case 'planned':
      return 'bg-newColors-purple-thirdA'
    case 'finished':
      return 'bg-newColors-green-primaryB'
    default:
      return ''
  }
})

const selectedIcon = computed(() => icons[props.item.projectState.toLowerCase()])
const breadcrumb = computed(() => `${props.item.county}${props.item.county === props.item.municipality ? '' : ' / ' + props.item.municipality}${props.item.municipality === props.item.publicArea ? '' : ' / ' + props.item.publicArea}`)

const closeItemInfo = () => {
  emit('closeItemInfo')
}

const GoToUrl = () => {
  window.location.href = props.item.projectUrl
}

const capitalizeFirstLetter = (string) => string.charAt(0).toUpperCase() + string.slice(1)
</script>

<style scoped>
.line-clamp {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
</style>
